class SecurityService {

    constructor($rootScope, $window, $http, initConfigProvider, tokenService) {
        this.rootScope = $rootScope;
        this.window = $window;
        this.http = $http;
        this.apiBaseUrl = initConfigProvider.apiBaseUrl;
        this.authServiceEndPoint = initConfigProvider.authServiceEndPoint;
        this.configProvider = initConfigProvider;
        this.tokenService = tokenService;
        this.sessionResultKey = "sessionValidationResult";
        this.nextValidationKey = "sessionValidationTime";
    }

    authenticate(username, password, targetId) {
        let url = `${this.apiBaseUrl}${this.authServiceEndPoint}`;
        return this._IECORSFix(url).then((r) => {
            return this._actOnResponse(url, this.tokenService, username, password, targetId);
        });
    }

    ssoAuthenticate() {
        let url = `${this.apiBaseUrl}${this.authServiceEndPoint}`;
        return this._IECORSFix(url).then((r) => {
            return this._actOnResponse(url, this.tokenService);
        });
    }

    logout() {
        if (this.hasSSOCookie()) {
            this.http.get(`${this.apiBaseUrl}/api/UserSession/SignOut`, { withCredentials: true }).then((response) => {
                this.tokenService.clearAutheticatedUserToken();
                this.clearSessionInfo();
            });
        } else {
            this.tokenService.clearAutheticatedUserToken();
            this.clearSessionInfo();
        }
    }

    validateUserSession() {
        const validationUrl = `${this.apiBaseUrl}/api/UserSession/ValidateSession`;

        if (!this.shouldRevalidateSession()) {
            return Promise.resolve(sessionStorage.getItem(this.sessionResultKey) === "true");
        }

        return this.http.get(validationUrl, { withCredentials: true }).then(
            (response) => {
                let result = response.data === "valid";
                this.saveSessionInfo(result);
                return result;
            }
        ).catch((err) => {
            console.log(err);
            this.clearSessionInfo();
            return false;
        });
    }

    isAuthenticated() {
        if (!this.tokenService.hasSSOToken() && sessionStorage.getItem(this.nextValidationKey) == null) {
            return Promise.resolve(this.tokenService.hasToken());
        }

        return this.validateUserSession().then(
            (result) => {
                return result;
            }
        ).catch((err) => {
            console.log(err);
            return false;
        });
    }

    clearSessionInfo() {
        sessionStorage.removeItem(this.sessionResultKey);
        sessionStorage.removeItem(this.nextValidationKey);
    }

    saveSessionInfo(result) {
        sessionStorage.setItem(this.sessionResultKey, result);

        let sessionRevalidationSeconds = parseInt(this.configProvider.sessionRevalidationSeconds);
        let nextValidation = ((new Date()).getTime() + sessionRevalidationSeconds * 1000);
        sessionStorage.setItem(this.nextValidationKey, (new Date(nextValidation)).toString());
    }

    shouldRevalidateSession() {
        if (sessionStorage.getItem(this.nextValidationKey) == null)
            return true;

        let validationTime = new Date(sessionStorage.getItem(this.nextValidationKey));
        let currentTime = new Date();
        if (currentTime < validationTime) {
            return false;
        } else {
            return true;
        }
    }

    hasSSOCookie() {
        return this.tokenService.hasSSOToken();
    }

    getAutheticatedUserId() {
        return this.tokenService.getAutheticatedUserTokenPayload().unique_name;
    }

    getAutheticatedUserRoles() {
        return this.tokenService.getAutheticatedUserTokenPayload().role;
    }

    getAutheticatedUserName() {
        return this.tokenService.getAutheticatedUserTokenPayload().given_name;
    }

    isAdmin() {
        let userRoles = this.getAutheticatedUserRoles();
        if (userRoles) {
            if (Array.isArray(userRoles)) {
                return userRoles.find(o => o === 'Admin') === null ? false : true;
            } else {
                return userRoles === 'Admin';
            }
        }
        return false;
    }

    getAutheticatedUserEmail() {
        return this.tokenService.getAutheticatedUserTokenPayload().email;
    }

    //This is a fix for the CORS issue in IE (XMLHttpRequest: Network Error 0x2ee4, Could not complete the operation due to error 00002ee4.)
    // found this solution http://jonnyreeves.co.uk/2013/making-xhr-request-to-https-domains-with-winjs/
    _IECORSFix(url) {
        return this.http({
            method: 'GET',
            url: url
        });
    }

    _actOnResponse(url, tokenService, username = null, password = null, targetId = null) {
        let formData;
        let useSSOCookie = username === null && password === null;
        if (!useSSOCookie) {
            formData = `grant_type=password&username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`;
            if (targetId !== null) {
                formData = `${formData}&targetId=${encodeURIComponent(targetId)}`;
            }
        } else {
            formData = "grant_type=sso_cookie";
        }

        return this.http({
            method: 'POST',
            url: url,
            data: formData,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
            withCredentials: useSSOCookie
        }).then((response) => {
            if (response.status === 200) {
                tokenService.setAutheticatedUserToken(response.data.access_token);
                return {
                    autheticated: true,
                    error: ''
                };
            } else {
                if (response.data && response.data.error) {
                    return {
                        autheticated: false,
                        error: response.data.error
                    };
                }
            }
            return {
                autheticated: false,
                error: 'Authentication service error'
            };
        }).catch((error) => {
            return {
                autheticated: false,
                error: 'Authentication service error'
            };
        });
    }


    static securityServiceFactory($rootScope, $window, $http, initConfigProvider, tokenService) {
        return new SecurityService($rootScope, $window, $http, initConfigProvider, tokenService);

    }

}

SecurityService.securityServiceFactory.$inject = ['$rootScope', '$window', '$http', 'initConfigProvider', 'tokenService'];

export default SecurityService;


// WEBPACK FOOTER //
// ./app/services/security.service.js